import styles from "./Buttons.module.css";
import chevron from "../../../assets/chevron.svg";

const AuditTitleButton = ({ text, onClickHandler, showQuestions }) => {
  let chevronClass = showQuestions ? styles.chevronFocused : styles.chevron;
  return (
    <button className={styles.auditTitleButton} onClick={onClickHandler}>
      <img className={chevronClass} src={chevron} alt="" />
      {text}
    </button>
  );
};

export default AuditTitleButton;
